/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import {CommonContractorCreateUpdateApp} from "../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import {ContractorCreateEmployeeApp} from "../../Functionality/EmployeeCreateUpdateFlows/ContractorCreateEmployeeApp";
import ManagerFields from "../ContractorCreateUpdateFlows/ManagerFields";
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import {ButtonNextStep, ButtonPrevStep} from '../../../../../components/buttons/ButtonNavigation';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import {ACTION_MODEL} from '../../../../../Helpers/ActionModel';
import {FILE_TYPE} from '../../../../../Helpers/fileType';
import {SUGGESTION_MODE_OPTION} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import SummaryEmployeeContractor from './SummaryEmployeeContractor';
import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';

const ContractorCreateEmployee = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        navigate,
        permission,
        dispatch,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        generatedPassword,
        setGeneratedPassword,
        secretModal, setSecretModal,
        secretKey, setSecretKey,
        passwordGenerator,
        photoPicker,
        setPhotoPicker,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        isValidPassword,
        setIsValidPassword,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        validatePassword,
        reset
    }  = props;

    const {
        user,
        setUser,
        FormHandler,
        steps,
        activeStep, setActiveStep,
        handleStepChange,
        handleClearAll,
        handleValidateSteps
    } = ContractorCreateEmployeeApp({
        t,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        isValidPassword,
        setIsValidPassword,
        reset,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        validateEmail,
        validatePhone,
        validatePassword
    });

    return (
        <>
            <HeadTittle
                link={routes.contractor.searchEmployee}
                name={t("create")}
            />

            <StepperTabs
                id={null}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                    <>
                        <ManagerFields
                            title={"user_data"}
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            isValidDocumentId={isValidDocumentId}
                            setIsValidDocumentId={setIsValidDocumentId}
                            isValidEmail={isValidEmail}
                            isValidPhoneNumber={isValidPhoneNumber}
                            isValidDob={isValidDob}
                            setIsValidDob={setIsValidDob}
                            handleEmailChange={handleEmailChange}
                            handlePasswordChange={handlePasswordChange}
                            handlePhoneNumberChange={handlePhoneNumberChange}
                            handleDateChange={handleDateChange}
                            statusList={userInfoStatusList}
                            handleClearAll={handleClearAll}
                        />
                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                            <ButtonNextStep
                                id='btn_ce_next_details'
                                text='next'
                                click={() => {
                                    if(handleValidateSteps(0)){
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }
                                }}
                            />
                        </div>
                    </>
                </StepTab>
                <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                    <>
                        <CustomPhotoPicker
                            id='fp_ce_create_photo_profile'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                            showBtnCamera={true}
                            validateFace={true}
                            classWith={'content-center-w-400px'}
                            showPreview={true}
                            typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_ce_back_other_details'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_ce_next_other_details'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => setActiveStep((prevStep) => prevStep + 1)}
                            />
                        </div>
                    </>
                </StepTab>
                <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                    <>
                        <SummaryEmployeeContractor
                            user={user}
                            photoPicker={photoPicker}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_ce_back_summary'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_ce_enroll'
                                text='create'
                                click={() => {
                                    FormHandler();
                                }}
                            />
                        </div>
                    </>
                </StepTab>
            </StepperTabs>


            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.contractor.searchEmployee);
                }}
                closeText={'continue'}
            />

        </>
    );
};

export default ContractorCreateEmployee;
